import { useQuery } from "@tanstack/react-query";
import { CalculatorKeys } from "web_myplann/Api/Calculators/CalculatorKeys";
import { getCalculatorAccess } from "web_myplann/Infrastructure/ApiOld/Api";

export const useGetDashboardPermissionsQuery = () => {
	return useQuery({
		queryKey: CalculatorKeys.dashboardPermissions(),
		queryFn: () => getCalculatorAccess(),
		select: (resp) => {
			if (!resp || resp.status !== 200) {
				return { mortgage: false, travelInsurance: false };
			}
			const items = resp.data?.data?.items ?? [];
			const byType = (t: string) =>
				items.find((i) => i.calculatorType === t)?.access ?? false;

			return {
				mortgage: byType("mortgage"),
				travelInsurance: byType("travelInsurance"),
			};
		},
	});
};
